export default __webpack_public_path__ + "static/media/doll_r.5cdd3d2e.svg";